import { Field, Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { AiOutlineMinus, AiOutlinePlus } from 'react-icons/ai';
import { MdOutlineCancel } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, CustomSelect, TextField } from 'src/components';
import DiscountCustomSelect from 'src/components/DiscountSelect/DiscountCustomSelect';
import ImageUploadWithPreview from 'src/components/image-upload-with-preview';
import Loader from 'src/components/loader';
import useFetch from 'src/hooks/useFetch';
import { RootState } from 'src/redux/reducers';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';
import * as Yup from 'yup';

interface InputItem {
  id: any;
  name: string;
  price: number;
  costPrice: number;

  isVeg: boolean;
  description: string;
  inStock: number;
  lowStock: number;
}

const FORM_VALIDATION = Yup.object().shape({
  name: Yup.string()
    .min(3, 'Item name must be at least 3 character long')
    .required('Item name is required'),

  price: Yup.number()
    .typeError('Price must be in number')
    .required('Price is required'),
  categoryId: Yup.string().required('Category Name is required'),
  // image: Yup.mixed().required('Item Image is required'),
});

const AddItems = ({}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const symbol = useSelector(
      ({ currencyData }: RootState) => currencyData.myCurrencyData?.symbol ?? 'Rs.'
  );

  const { editItemsData } = useSelector(
    ({ itemEditData }: RootState) => itemEditData
  );
  const [EditItemsData, setEditItemsData] = useState(
    location.pathname == '/edit-item' ? editItemsData : ''
  );

  const { categoryData: editCategory } = useSelector(
    ({ itemCategory }: RootState) => itemCategory
  );
  const { data: Category } = useFetch('/categories');

  let categoryData = EditItemsData ? editCategory : Category.categories;

  const [addVariants, setAddVariants] = React.useState(
    EditItemsData?.hasVariants || false
  );
  const [showSquareShape, setShowSquareShape] = React.useState(true);
  const [showImage, setShowImage] = React.useState(true);
  const [showCircleShape, setShowCircleShape] = React.useState(false);
  const [previewImage, setPreviewImage] = React.useState<any>(
    EditItemsData ? EditItemsData?.image : ''
  );
  const [isLoading, setIsloading] = React.useState<boolean>(false);
  const [selectColor, setSelectColor] = React.useState('#EF476F');
  const { data: modifiersData } = useFetch('/modifiers');
  const [showModal, setShowModal] = React.useState(false);
  const [inStock, setInStock] = React.useState(
    EditItemsData ? EditItemsData?.variants[0].inStock : 0
  );
  const [lowStock, setLowStock] = React.useState(
    EditItemsData ? EditItemsData?.variants[0].lowStock : 0
  );
  const [trackStockChecked, setTrackStockChecked] = React.useState(
    EditItemsData ? EditItemsData?.trackStock : false
  );
  const [hasSpiceLevelChecked, setHasSpiceLevelChecked] = React.useState(
    EditItemsData ? EditItemsData?.hasSpiceLevel : false
  );

  const [isVegChecked, setIsVegChecked] = React.useState(
    EditItemsData ? EditItemsData?.variants[0]?.isVeg : null
  );

  const [isHidden, setIsHidden] = React.useState(false);

  const [inputs, setInputs] = useState<any>(
    EditItemsData
      ? EditItemsData?.variants || []
      : [
          {
            name: '',
            price: 0,
            costPrice: 0,
            isVeg: false,
            description: '',
            inStock: 0,
            lowStock: 0,
          },
        ]
  );
  const [showDescription, setShowDescription] = useState(() => {
    if (EditItemsData) {
      return EditItemsData.variants.map((variant: any) =>
        Boolean(variant.description)
      );
    } else {
      return Array(inputs.length).fill(false);
    }
  });

  const handleInputChange = (
    index: number,
    name: keyof InputItem,
    value: string | number
  ) => {
    const updatedInputs = [...inputs];

    if (name === 'price' || name === 'costPrice') {
      updatedInputs[index][name] =
        typeof value === 'number'
          ? value
          : isNaN(parseFloat(value))
          ? 0
          : parseFloat(value);
    } else {
      (updatedInputs[index] as any)[name] = value;
    }

    setInputs(updatedInputs);
  };

  const handleOnChangeCheckBox = (
    index: number,
    name: keyof InputItem,
    checked: any
  ) => {
    const updatedInputs: any = [...inputs];

    (updatedInputs[index] as any)[name] = checked;
    setInputs(updatedInputs);
  };

  const handleAddMoreVariants = () => {
    setInputs([
      ...inputs,
      {
        id: '',
        name: '',
        price: 0,
        costPrice: 0,

        isVeg: null,
        description: '',
        inStock: 0,
        lowStock: 0,
      },
    ]);
    setAddVariants(true);
  };

  const handleDeleteVariant = (index: number) => {
    const updatedInputs = [...inputs];
    updatedInputs.splice(index, 1);
    setInputs(updatedInputs);
    if (updatedInputs.length < 1) {
      setAddVariants(false);
      setInputs(
        EditItemsData
          ? EditItemsData?.variants || []
          : [
              {
                name: '',
                isVeg: false,
                description: '',
                dineInInfo: { isAvailable: true, price: 0 },
                takeawayInfo: {},
                deliverInfo: {},
                price: 0,
                costPrice: 0,
                inStock: 0,
                lowStock: 0,
              },
            ]
      );
    }
  };

  const handleAddDescription = (index: number) => {
    setShowDescription((prev: any) => {
      const updatedShowDescription = [...prev];
      updatedShowDescription[index] = !updatedShowDescription[index];
      return updatedShowDescription;
    });
  };

  React.useEffect(() => {
    if (EditItemsData?.color) {
      setSelectColor(EditItemsData.color);
      if (EditItemsData.shape === 'circle') {
        setShowSquareShape(false);
        setShowCircleShape(true);
      } else {
        setShowSquareShape(true);
        setShowCircleShape(false);
      }
    }
  }, [EditItemsData]);
  useEffect(() => {
    if (EditItemsData && EditItemsData?.image !== null) {
      setShowImage(true);
    }
  }, [EditItemsData]);

  const filterCategory = categoryData
    ? categoryData?.map((item: any) => {
        return {
          name: item?.categoryInfo?.name,
          id: item?.categoryInfo?.id,
        };
      })
    : [];

  const initValues = {
    variants: inputs,
    name: EditItemsData ? EditItemsData.name : '',
    categoryId: EditItemsData ? EditItemsData?.category?.id : '',
    modifiers: EditItemsData
      ? EditItemsData?.modifiers?.map((modifier: any) => modifier.id)
      : [],
    price: EditItemsData ? EditItemsData?.variants[0].price : 0,
    costPrice: EditItemsData ? EditItemsData?.variants[0].costPrice : 0,
    description: EditItemsData ? EditItemsData?.description : '',
    image: EditItemsData ? EditItemsData?.image : '',
    inStock: EditItemsData ? EditItemsData?.variants[0].inStock : 0,
    lowStock: EditItemsData ? EditItemsData?.variants[0].lowStock : 0,
  };

  const handleModal = () => {
    setShowModal(!showModal);
    setAddVariants(!addVariants);
  };

  const handleWithOutVariant = async (val: any, { resetForm }: any) => {
    const itemsPayload = {
      name: val?.name,
      categoryId: val?.categoryId,
      sellingType: 'each',
      hasVariants: addVariants,
      id: EditItemsData ? EditItemsData?.id : '',
      modifiers: val?.modifiers ? val?.modifiers : [],
      description: val?.description,
      trackStock: trackStockChecked,
      hasSpiceLevel: hasSpiceLevelChecked,
      color: selectColor,
      image: showImage && (!isHidden || previewImage?.name) ? val?.image : '',
      shape: showCircleShape ? 'circle' : showSquareShape ? 'square' : '',
      variants: addVariants
        ? inputs
        : [
            {
              id: inputs[0]?.id,
              name: val?.name,
              price: parseFloat(val?.price),
              costPrice: parseFloat(val?.costPrice),
              description: val?.description,
              isVeg: isVegChecked,
              inStock: Math.trunc(
                typeof inStock === 'number' ? inStock : parseInt(inStock, 10)
              ),
              lowStock: Math.trunc(
                typeof lowStock === 'number' ? lowStock : parseInt(lowStock, 10)
              ),
            },
          ],
    };
    try {
      if (EditItemsData) {
        await Service.put('/items/edit', itemsPayload);
      } else {
        await Service.post('/items/create', itemsPayload);
      }

      toastAlert(
        'success',
        `${val?.name} is successfully ${
          location.pathname == '/edit-item' ? 'edited' : 'Created'
        }`
      );
      resetForm();
      !EditItemsData && setIsloading(true);
      setTimeout(() => setIsloading(false), 100);
      setInputs([
        {
          name: '',
          isVeg: false,
          description: '',
          dineInInfo: { isAvailable: true, price: 0 },
          takeawayInfo: {},
          deliverInfo: {},
          price: 0,
          costPrice: 0,
          inStock: 0,
          lowStock: 0,
        },
      ]);
      setAddVariants(false);
      setPreviewImage('');
      setSelectColor('#EF476F');
      setShowSquareShape(true);
      setShowCircleShape(false);
      navigate('/items-list');
    } catch (err: any) {
      toastAlert('error', err?.response?.data?.message);
    }
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <Formik
          initialValues={initValues}
          onSubmit={handleWithOutVariant}
          validationSchema={FORM_VALIDATION}
          validateOnMount
        >
          {({ isSubmitting, isValid, setFieldValue }) => (
            <Form className="text-black relative pb-20  overflow-hidden w-full">
              <div className="border border-light-gray p-6 rounded-xl w-[max-content] ">
                <div className="mb-14 col-span-5 sm:w-[calc(340px*2+49.92px)] 2xl:w-[calc(340px*3+49.92px*2)] relative flex sm:flex-wrap 2xl:flex-nowrap gap-[32px_49.92px]">
                  <div className="sm:w-[340px] 2xl:w-[calc(340px*2+49.92px)] flex flex-wrap gap-[49.92px]">
                    <div className="w-[340px] ">
                      <h5 className="mb-5 font-semibold text-xl">
                        Basic Information{' '}
                      </h5>
                      <TextField
                        placeholder="Enter item"
                        name="name"
                        label={'Item Name'}
                        defaultValue={
                          EditItemsData && EditItemsData
                            ? EditItemsData?.name
                            : ''
                        }
                      />

                      <Field
                        name="categoryId"
                        className="mt-3"
                        options={filterCategory ?? []}
                        component={CustomSelect}
                        defaultValue={
                          EditItemsData && EditItemsData
                            ? EditItemsData?.category?.name
                            : ''
                        }
                        isMulti={false}
                        label="Category"
                        placeholder={'Select a category'}
                      />

                      {addVariants ? (
                        ''
                      ) : (
                        <>
                          <TextField
                            name="price"
                            label={'Price'}
                            type="text"
                            defaultValue={
                              EditItemsData
                                ? EditItemsData?.variants[0]?.price
                                : ''
                            }
                            placeholder="Price"
                          />
                        </>
                      )}
                      {addVariants ? (
                        ''
                      ) : (
                        <>
                          <TextField
                            name="costPrice"
                            label={'Cost Price'}
                            type="text"
                            defaultValue={
                              EditItemsData
                                ? EditItemsData?.variants[0]?.costPrice
                                : ''
                            }
                            placeholder="Cost Price"
                          />
                        </>
                      )}
                      <div className="my-4 flex flex-col">
                        <label htmlFor="">Description</label>

                        <Field
                          as="textarea"
                          className="border-[1px] border-light-gray rounded-xl px-1 py-2 focus:border-[1px] focus:border-primary-200 mt-3 focus:shadow-none focus:ring-0 focus:outline-none"
                          rows={6}
                          cols={36}
                          placeholder="Enter Description"
                          name="description"
                          id="description"
                          defaultValue={
                            EditItemsData
                              ? EditItemsData?.variants[0]?.description
                              : ''
                          }
                        />
                      </div>
                    </div>

                    <div className="w-[340px]">
                      <h5 className="text-xl font-semibold">
                        Representation on POS
                      </h5>
                      {/* <div className="flex items-center space-x-4 mb-10 mt-7"> */}
                      {/* <button
                          onClick={handleImage}
                          type="button"
                          className={`${
                            !showImage
                              ? 'bg-primary text-pure-white rounded-full'
                              : 'text-text-black'
                          } py-1 px-4`}
                        >
                          Shape
                        </button>
                        <button
                          onClick={handleImage}
                          type="button"
                          className={`${
                            showImage
                              ? 'bg-primary text-pure-white rounded-full'
                              : 'text-text-black'
                          } py-1 px-4 `}
                        >
                          Image
                        </button>
                      </div>
                      {showImage ? ( */}
                      <div className="relative">
                        <div className="z-100">
                          <ImageUploadWithPreview
                            isHidden={isHidden}
                            setIsHidden={setIsHidden}
                            label="Upload Image"
                            previewImage={previewImage}
                            setPreviewImage={setPreviewImage}
                            setFieldValue={setFieldValue}
                          />
                        </div>
                      </div>
                      {/* ) : (
                        <>
                          <div className="flex items-center space-x-10 mb-10">
                            <div
                              onClick={() => {
                                setShowSquareShape(true);
                                setShowCircleShape(false);
                              }}
                              className={`${
                                showSquareShape
                                  ? 'border-primary'
                                  : 'border-border-color-dark'
                              }  h-16 w-16 border border-border-color-dark flex items-center justify-center cursor-pointer rounded`}
                            >
                              {showSquareShape && (
                                <BsCheckCircleFill color="#4062FF" />
                              )}
                            </div>
                            <div
                              onClick={() => {
                                setShowSquareShape(false);
                                setShowCircleShape(true);
                              }}
                              className={`$ {
                        showCircleShape
                          ? 'border-primary'
                          : 'border-border-color-dark'
                      }  h-16 w-16 border border-border-color-dark flex items-center justify-center cursor-pointer rounded-full`}
                            >
                              {showCircleShape && (
                                <BsCheckCircleFill color="#4062FF" />
                              )}
                            </div>
                          </div>
                          <div className="grid grid-cols-4 p-5 gap-[20px_28px] bg-almost-white rounded-xl items-center justify-center place-items-center">
                            {categoryRepresentationPos?.map((item) => (
                              <div
                                className={`${
                                  showCircleShape ? 'rounded-full' : 'rounded'
                                } ${
                                  item?.color === selectColor &&
                                  'border-primary border-2'
                                } h-[55px] w-[55px] shadow-xl cursor-pointer hover:ease-in-out transform hover:scale-[10px] transition-all duration-700`}
                                key={item?.id}
                                style={{ backgroundColor: `${item?.color}` }}
                                onClick={() => setSelectColor(item?.color)}
                              />
                            ))}
                          </div>
                        </>
                      )} */}
                    </div>
                  </div>
                  <div className="w-[340px] flex flex-col gap-8">
                    <div className="col-span-6 ">
                      <h5 className="mb-3 font-semibold text-xl">Modifiers </h5>
                      <div className="flex gap-4 flex-col">
                        <Field
                          name="modifiers"
                          options={modifiersData?.modifiers ?? ''}
                          component={DiscountCustomSelect}
                          isMulti={true}
                          className="m-0"
                          label=""
                          placeholder="Select Modifier"
                          defaultValue={EditItemsData?.modifiers?.map(
                            (item: any) => {
                              return {
                                label: item.name,
                                value: item.id,
                              };
                            }
                          )}
                        />

                        <div className="flex items-center justify-between">
                          <h4 className="font-semibold text-xl">Track Stock</h4>
                          <label>
                            <Field
                              type="checkbox"
                              name="trackStock"
                              checked={trackStockChecked}
                              onChange={() =>
                                setTrackStockChecked(!trackStockChecked)
                              }
                            />
                          </label>
                        </div>

                        {trackStockChecked && !addVariants && (
                          <div className="flex flex-col gap-1">
                            <div className="flex gap-6">
                              <span>In Stock</span>
                              <span>Low Stock</span>
                            </div>
                            <div className="flex gap-4">
                              <input
                                type="text"
                                className="w-16 p-1 text-text-black border border-border-color-dark h-6 rounded focus:outline-none"
                                value={inStock}
                                required
                                onChange={(e: any) =>
                                  setInStock(e.target.value)
                                }
                              />
                              <input
                                type="text"
                                className="w-16 p-1 text-text-black border border-border-color-dark h-6 rounded focus:outline-none"
                                value={lowStock}
                                required
                                onChange={(e: any) =>
                                  setLowStock(e.target.value)
                                }
                              />
                            </div>
                          </div>
                        )}

                        <div className="flex items-center justify-between">
                          <h4>Has Spice Level</h4>
                          <label
                            htmlFor="hasSpiceLevel"
                            className="toggle inline-block w-12 h-6 bg-gray-100 rounded-full border-2 border-light-gray relative cursor-pointer"
                          >
                            <div
                              className={`absolute w-6 h-6 rounded-[50%] -top-[2px] -left-[2px] bg-light-gray transition-transform duration-650 ${
                                hasSpiceLevelChecked
                                  ? 'transform translate-x-full bg-primary'
                                  : ''
                              }`}
                            ></div>
                            <input
                              type="checkbox"
                              id="hasSpiceLevel"
                              name="hasSpiceLevel"
                              className="hidden"
                              checked={hasSpiceLevelChecked}
                              onChange={() =>
                                setHasSpiceLevelChecked(!hasSpiceLevelChecked)
                              }
                            />
                          </label>
                        </div>
                        {addVariants ? (
                          ''
                        ) : (
                          <div className="flex text-base justify-between flex-col gap-2">
                            <h4> Diet Category</h4>

                            <div className="flex gap-6 text-sm">
                              <label className="flex items-center gap-2">
                                <input
                                  type="radio"
                                  name="foodType"
                                  value="true"
                                  checked={isVegChecked}
                                  onChange={() => setIsVegChecked(true)}
                                />
                                Veg
                              </label>

                              <label className="flex items-center gap-2">
                                <input
                                  type="radio"
                                  name="foodType"
                                  value="false"
                                  checked={
                                    !isVegChecked && isVegChecked !== null
                                  }
                                  onChange={() => setIsVegChecked(false)}
                                />
                                Non-Veg
                              </label>

                              <label className="flex items-center gap-2">
                                <input
                                  type="radio"
                                  name="foodType"
                                  value="null"
                                  checked={isVegChecked === null}
                                  onChange={() => setIsVegChecked(null)}
                                />
                                Neither
                              </label>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div>
                      <h5 className="text-xl font-semibold ">Variants</h5>
                      {addVariants ? (
                        <>
                          <div className="flex">
                            <div className="w-full">
                              {inputs.map((input: any, index: number) => (
                                <div
                                  key={index}
                                  className="mt-5 focus:border-1 relative  focus:border-primary-200 focus:shadow-none focus:ring-0 focus:outline-none  border-[1px] border-light-gray  rounded-xl p-3"
                                >
                                  <div className="w-full ">
                                    <div className="flex  w-full  gap-4 flex-col">
                                      <div className="w-full">
                                        <input
                                          type="text"
                                          name="name"
                                          value={input.name}
                                          required
                                          placeholder="Name"
                                          onChange={(e) =>
                                            handleInputChange(
                                              index,
                                              'name',
                                              e.target.value
                                            )
                                          }
                                          className="w-full p-1 text-text-black border  border-border-color-dark h-10 rounded focus:outline-none "
                                        />
                                      </div>
                                      <div className="flex gap-4 justify-between">
                                        <div className="relative">
                                          <span className="absolute bg-pure-white text-[14px] left-1 px-[2.5px] -top-2.5">
                                            {symbol}
                                          </span>
                                          <input
                                            type="text"
                                            name="price"
                                            placeholder="Price"
                                            value={Number(input.price)}
                                            required
                                            onChange={(e) =>
                                              handleInputChange(
                                                index,
                                                'price',
                                                e.target.value
                                              )
                                            }
                                            className=" w-[100px] h-10 p-1 text-text-black border border-border-color-dark rounded focus:outline-none "
                                          />
                                        </div>

                                        <div className="flex gap-4 text-sm  border-[1px] border-light-gray  rounded-[4px]  px-3">
                                          <label className="flex flex-col items-center gap-1 -translate-y-[7px]">
                                            <input
                                              type="radio"
                                              name={`foodType-${index}`}
                                              checked={input.isVeg}
                                              onChange={(e) =>
                                                handleOnChangeCheckBox(
                                                  index,
                                                  'isVeg',
                                                  true
                                                )
                                              }
                                            />
                                            Veg
                                          </label>

                                          <label className="flex flex-col items-center gap-1 -translate-y-[7px]">
                                            <input
                                              type="radio"
                                              name={`foodType-${index}`}
                                              checked={
                                                !input.isVeg &&
                                                input.isVeg !== null
                                              }
                                              onChange={(e) =>
                                                handleOnChangeCheckBox(
                                                  index,
                                                  'isVeg',
                                                  false
                                                )
                                              }
                                            />
                                            Non-Veg
                                          </label>

                                          <label className="flex flex-col items-center gap-1 -translate-y-[7px]">
                                            <input
                                              type="radio"
                                              name={`foodType-${index}`}
                                              checked={
                                                !input.isVeg &&
                                                input.isVeg === null
                                              }
                                              onChange={(e) =>
                                                handleOnChangeCheckBox(
                                                  index,
                                                  'isVeg',
                                                  null
                                                )
                                              }
                                            />
                                            Neither
                                          </label>
                                        </div>
                                      </div>
                                      <div className="relative">
                                        <span className="absolute bg-pure-white text-[14px] left-1 px-[2.5px] -top-2.5">
                                          Cost Price
                                        </span>
                                        <input
                                          type="text"
                                          name="costPrice"
                                          placeholder="Cost Price"
                                          value={Number(input.costPrice)}
                                          required
                                          onChange={(e) =>
                                            handleInputChange(
                                              index,
                                              'costPrice',
                                              e.target.value
                                            )
                                          }
                                          className=" w-[100px] h-10 p-1 text-text-black border border-border-color-dark rounded focus:outline-none "
                                        />
                                      </div>
                                      {trackStockChecked && (
                                        <div className="flex flex-col gap-1">
                                          <div className="flex gap-6">
                                            <span>In Stock</span>
                                            <span>Low Stock</span>
                                          </div>
                                          <div className="flex gap-4">
                                            <input
                                              type="text"
                                              className="w-16 p-1 text-text-black border border-border-color-dark h-6 rounded focus:outline-none"
                                              value={input.inStock}
                                              required
                                              onChange={(e: any) =>
                                                handleInputChange(
                                                  index,
                                                  'inStock',
                                                  isNaN(
                                                    parseInt(e.target.value)
                                                  )
                                                    ? 0
                                                    : parseInt(e.target.value)
                                                )
                                              }
                                            />
                                            <input
                                              type="text"
                                              className="w-16 p-1 text-text-black border border-border-color-dark h-6 rounded focus:outline-none"
                                              value={input.lowStock}
                                              required
                                              onChange={(e: any) =>
                                                handleInputChange(
                                                  index,
                                                  'lowStock',
                                                  isNaN(
                                                    parseInt(e.target.value)
                                                  )
                                                    ? 0
                                                    : parseInt(e.target.value)
                                                )
                                              }
                                            />
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                    <div className="absolute rounded-1/2 -right-[5px] -top-[8px] bg-pure-white">
                                      <button
                                        className="flex justify-end"
                                        type="button"
                                        onClick={() =>
                                          handleDeleteVariant(index)
                                        }
                                      >
                                        <MdOutlineCancel
                                          size={20}
                                          color="#f02222"
                                        />
                                      </button>
                                    </div>
                                    <div>
                                      <p
                                        onClick={() =>
                                          handleAddDescription(index)
                                        }
                                        className="flex  items-center mt-4 text-primary-400 cursor-pointer text-[#4062FF]"
                                      >
                                        {showDescription[index] ? (
                                          <AiOutlineMinus size={'15px'} />
                                        ) : (
                                          <AiOutlinePlus size={'15px'} />
                                        )}
                                        Description
                                      </p>
                                    </div>

                                    {showDescription[index] && (
                                      <div className="mt-1">
                                        <textarea
                                          className="border-[1px] border-light-gray rounded-xl px-1 py-2 focus:border-[1px] focus:border-primary-200 mt-3 focus:shadow-none focus:ring-0 focus:outline-none"
                                          rows={4}
                                          cols={36}
                                          name="description"
                                          id="description"
                                          value={input.description}
                                          onChange={(e) =>
                                            handleInputChange(
                                              index,
                                              'description',
                                              e.target.value
                                            )
                                          }
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div>
                              ))}
                              <div className="flex items-center justify-center ">
                                <button
                                  type="button"
                                  className="mx-auto"
                                  onClick={handleAddMoreVariants}
                                >
                                  <Button
                                    text="add more"
                                    variant="outline"
                                    type="button"
                                    className="w-full mt-8 mb-0"
                                  />
                                </button>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        ''
                      )}

                      {addVariants ? (
                        ''
                      ) : (
                        <Button
                          text="add variants"
                          icon={<AiOutlinePlus size={20} color="#4062FF" />}
                          variant="outline"
                          type="button"
                          className="w-full mt-3 py-4 mb-0"
                          onClick={handleModal}
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="flex items-center pb-5">
                  <Button
                    type="submit"
                    text={EditItemsData ? 'Edit Item' : 'Add Item'}
                    isSubmitting={isSubmitting}
                    isValid={isValid}
                    variant="primary"
                    className="px-10"
                  />
                </div>
              </div>
            </Form>
          )}
        </Formik>
      )}
    </>
  );
};

export default AddItems;
